import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import { IVacanciesData } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/custom/useToast";
import { useLoader } from "../context/LoaderContext";
import { useMobile } from "../hooks/custom/useMobile";
import useTab from "../hooks/custom/useTab";
import { fetchAcademicVacancies } from "../api/VacanciesApi";
import AcademicSidebar from "../components/vacancies/AcademicSidebar";
import AcademicContent from "../components/vacancies/AcademicContent";

const AcademicVacanciesPage = () => {
  const { setLoading } = useLoader();
  const mobile = useMobile();
  const tab = useTab();
  const [openSidebar, setOpenSidebar] = useState(false);
  const [vacancies, setVacancies] = useState<IVacanciesData[]>([]);
  const [selectedVacancies, setSelectedVacancies] = useState<string>("");
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchAcademicVacancies()])
      .then(([vacanciesData]) => {
        setVacancies(vacanciesData);
        setLoading(false);
        setSelectedVacancies(vacanciesData[0]?.adv_code);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
        setLoading(false);
      });
  }, [setLoading]);

  const selectedVacanciesDetails = vacancies.find(
    (item) => item.adv_code === selectedVacancies,
  );

  return (
    <>
      <Banner title="Academics" />
      <section id="introduction">
        <div className="td_height_120 td_height_lg_40" />
        <div className="td_about td_style_1">
          <div className="container">
            {(mobile || tab) && (
              <div className="course_sidebar_toggle_wrapper td_mb_20">
                <h3 className="mb-0">Academic Vacancies</h3>
                <button
                  className="course_sidebar_toggle mt-1"
                  onClick={() => setOpenSidebar(true)}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                  {/* <span></span>
                  <span></span>
                  <span></span> */}
                </button>
              </div>
            )}
            <div className="row td_gap_y_40 td_mb_40">
              <AcademicSidebar
                vacancies={vacancies}
                selectedVacancies={selectedVacancies}
                setSelectedVacancies={setSelectedVacancies}
                openSidebar={openSidebar}
                setOpenSidebar={setOpenSidebar}
              />
              <AcademicContent
                selectedVacanciesDetails={selectedVacanciesDetails}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AcademicVacanciesPage;
